import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import { LeafletProvider, createLeafletContext } from '@react-leaflet/core';
import { Map as LeafletMap } from 'leaflet';
import React, { forwardRef, useCallback, useEffect, useImperativeHandle, useState } from 'react';

function MapContainerComponent(_ref, forwardedRef) {
  var bounds = _ref.bounds,
      boundsOptions = _ref.boundsOptions,
      center = _ref.center,
      children = _ref.children,
      className = _ref.className,
      id = _ref.id,
      placeholder = _ref.placeholder,
      style = _ref.style,
      whenReady = _ref.whenReady,
      zoom = _ref.zoom,
      options = _objectWithoutPropertiesLoose(_ref, ["bounds", "boundsOptions", "center", "children", "className", "id", "placeholder", "style", "whenReady", "zoom"]);

  var _useState = useState({
    className: className,
    id: id,
    style: style
  }),
      props = _useState[0];

  var _useState2 = useState(null),
      context = _useState2[0],
      setContext = _useState2[1];

  useImperativeHandle(forwardedRef, function () {
    var _context$map;

    return (_context$map = context == null ? void 0 : context.map) != null ? _context$map : null;
  }, [context]);
  var mapRef = useCallback(function (node) {
    if (node !== null && context === null) {
      var map = new LeafletMap(node, options);

      if (center != null && zoom != null) {
        map.setView(center, zoom);
      } else if (bounds != null) {
        map.fitBounds(bounds, boundsOptions);
      }

      if (whenReady != null) {
        map.whenReady(whenReady);
      }

      setContext(createLeafletContext(map));
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, []);
  useEffect(function () {
    return function () {
      context == null ? void 0 : context.map.remove();
    };
  }, [context]);
  var contents = context ? /*#__PURE__*/React.createElement(LeafletProvider, {
    value: context
  }, children) : placeholder != null ? placeholder : null;
  return /*#__PURE__*/React.createElement("div", _extends({}, props, {
    ref: mapRef
  }), contents);
}

export var MapContainer = /*#__PURE__*/forwardRef(MapContainerComponent);